const catalogs = {
  ORDEM_MENUS_PEP: {
    ids: ["_ordemdosmenusboard", "_ocultarmenusboard"], titles: ["Ordem dos Menus", "Ocultar Menus"],
    items: [["visaoGeral", "Visão Geral"], ["resumoIA", "Resumo com IA"], ["minhaVisualizacao", "Minha Visualização"], ["atendimentos", "Fichas"], ["documentos", "Documentos"],
      ["medicacoes", "Medicamentos"], ["receituario", "Receituário"], ["imagens", "Imagens"], ["cid", "CID"], ["internacao", "Internação"],
      ["consultas", "Consultas"], ["exames", "Exames"], ["cirurgias", "Cirurgias"], ["solicitacoes", "Solicitações"], ["agendasRetorno", "Gestão de Retorno"]]
  },
  BOTOES_INCLUSAO_PEP: {
    ids: ["_botoesinclusaoboard", "_ocultarbotoesinclusaoboard"], titles: ["Botões de Inclusão", "Ocultar Botões"],
    items: [["adicionarCID", "Adicionar CID"], ["adicionarMedicamentosTexto", "Adicionar Medicamentos / Textos"], ["adicionarTextosRapido", "Adicionar Textos (Rápido)"],
      ["adicionarImagensMultimidia", "Adicionar Imagens e Multimídia"], ["areasAtendimento", "Áreas Atendimento"], ["adicionarFicha", "Adicionar Ficha"],
      ["inserirArquetipos", "Inserir Arquetipos"], ["iniciarTeleatendimento", "Iniciar Teleatendimento"], ["gestaoRetorno", "Gestão de Retorno"],
      ["solicitarProcedimentos", "Solicitar Procedimentos"], ["informacoesTiss", "Informações TISS"]]
  }
};
export const copiarLayout = value => JSON.parse(JSON.stringify(value));
export const camposMinhaVisualizacao = [
  ["atendimentos", "Fichas"], ["documentos", "Documentos"], ["medicacoes", "Medicações"], ["receituario", "Receituário"],
  ["imagens", "Imagens"], ["cid", "CID"], ["internacao", "Internação"], ["consultas", "Consultas"], ["exames", "Exames"],
  ["cirurgias", "Cirurgias"], ["solicitacoes", "Solicitações"], ["agendasRetorno", "Gestão de Retorno"]
];
export const campoMinhaVisualizacao = "MENU_MINHA_VISUALIZACAO";
export function layoutPadrao(campo) {
  if(campo === campoMinhaVisualizacao) { return Object.fromEntries(camposMinhaVisualizacao.map(([id]) => [id, "0"])); }
  const spec = catalogs[campo];
  return spec.ids.map((id, index) => ({ id, title: spec.titles[index], class: "bg-light-primary", item: index ? [] : spec.items.map(([id, title]) => ({ id, title })) }));
}
export function normalizarLayout(campo, value) {
  if(campo === campoMinhaVisualizacao) {
    if(!value || typeof value !== "object" || Array.isArray(value)) { throw new Error("Opções inválidas."); }
    const result = copiarLayout(value);
    for(const [id] of camposMinhaVisualizacao) {
      const valor = value[id];
      if([true, 1, "1", "true"].includes(valor)) { result[id] = "1"; }
      else if([false, 0, "0", "false", "", null, undefined].includes(valor)) { result[id] = "0"; }
      else { throw new Error("Opção inválida."); }
    }
    return result;
  }
  const spec = catalogs[campo], defaults = layoutPadrao(campo), seen = new Set();
  if(!Array.isArray(value) || value.length !== 2 || new Set(value.map(b => b?.id)).size !== 2 || value.some(b => !spec.ids.includes(b?.id) || !Array.isArray(b.item))) { throw new Error("Listas inválidas."); }
  const boards = defaults.map(def => {
    const board = value.find(b => b.id === def.id);
    const item = board.item.map(item => {
      if(!item || typeof item.id !== "string" || !item.id || typeof item.title !== "string" || seen.has(item.id)) { throw new Error("Item inválido ou repetido."); }
      seen.add(item.id); return copiarLayout(item);
    });
    return { ...copiarLayout(board), ...{ id: def.id, title: def.title, class: def.class, item } };
  });
  // Configurações de versões anteriores ganham os itens novos sem reexibir os ocultados.
  for(const [id, title] of spec.items) { if(!seen.has(id)) {
    const after = id === "resumoIA" ? boards[0].item.findIndex(item => item.id === "visaoGeral") : -1;
    if(after >= 0) { boards[0].item.splice(after + 1, 0, { id, title }); } else { boards[0].item.push({ id, title }); }
  } }
  return boards;
}
export function decodificarLayout(campo, texto) {
  if(texto === "" || texto == null) { return layoutPadrao(campo); }
  if(typeof texto !== "string") { throw new Error("Configuração inválida."); }
  let json = texto;
  if(campo === "BOTOES_INCLUSAO_PEP" || campo === campoMinhaVisualizacao) {
    let base = texto.replace(/\s/g, "").replace(/-/g, "+").replace(/_/g, "/");
    if(!/^[A-Za-z0-9+/]*={0,2}$/.test(base) || base.length % 4 === 1) { throw new Error("Base64 inválido."); }
    base += "=".repeat((4 - base.length % 4) % 4);
    const bytes = atob(base);
    try { json = decodeURIComponent(Array.from(bytes, c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join("")); }
    catch(error) { json = bytes; } // Compatibilidade com configurações antigas em Latin-1.
  }
  return normalizarLayout(campo, JSON.parse(json));
}
export function codificarLayout(campo, boards) {
  const value = normalizarLayout(campo, boards);
  if(campo === campoMinhaVisualizacao) { for(const [id] of camposMinhaVisualizacao) { value[id] = value[id] === "1"; } }
  const json = JSON.stringify(value);
  return campo === "ORDEM_MENUS_PEP" ? json : btoa(encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16))));
}
export const contextoMinhaVisualizacao = vm => JSON.stringify([vm.usuario, vm.idEmitenteML, vm.$route.fullPath, vm.minhaVisualizacaoRevisao]);
export function aplicarMinhaVisualizacao(vm, configuracao, contexto = contextoMinhaVisualizacao(vm)) {
  if(contexto !== contextoMinhaVisualizacao(vm)) { return false; }
  try {
    if(!configuracao || !("TEXTO" in configuracao)) { throw new Error("Resposta inválida."); }
    const value = decodificarLayout(campoMinhaVisualizacao, configuracao.TEXTO);
    vm.minhaVisualizacao = value; vm.erroMinhaVisualizacao = "";
    if(vm.menuSelecionado === "minhaVisualizacao" && !camposMinhaVisualizacao.some(([id]) => value[id] === "1")) { vm.selecionarMenu("visaoGeral"); }
    return true;
  } catch(error) {
    vm.erroMinhaVisualizacao = "Não foi possível aplicar Minha Visualização. A seleção atual foi mantida."; return false;
  }
}
export function moverItemLayout(campo, boards, { boardOrigem, boardDestino, item, ordem }) {
  const copy = normalizarLayout(campo, boards), source = copy.find(b => b.id === boardOrigem), target = copy.find(b => b.id === boardDestino);
  const index = source?.item.findIndex(r => r.id === item) ?? -1, position = Number(ordem);
  const max = target ? target.item.length + (source === target ? 0 : 1) : 0;
  if(!source || !target || index < 0 || !Number.isInteger(position) || position < 1 || position > max) { throw new Error("Movimento inválido. A ordem anterior foi preservada."); }
  const [record] = source.item.splice(index, 1); target.item.splice(position - 1, 0, record); return copy;
}
export function menusDoLayout(boards, minhaVisualizacao) {
  return boards[0].item.filter(item => catalogs.ORDEM_MENUS_PEP.items.some(([id]) => id === item.id)).map(item => ({
    titulo: item.title, nome: item.id, desativado: false,
    vizualiza: item.id !== "minhaVisualizacao" || catalogs.ORDEM_MENUS_PEP.items.some(([id]) => id !== "minhaVisualizacao" && String(minhaVisualizacao?.[id]) === "1")
  }));
}
export const pedidoLeituraLayout = (campo, usuario) => ({ CAMPO: campo, USUARIO: String(usuario || "").trim(), ACAO: "LER", ID_CLIENT_REQUEST: "ler:" + campo + ":" + String(usuario || "").trim() });
export function respostaLayout(res, req) {
  return res?.contrato === "LAYOUT_PEP_V1" && ["CAMPO", "USUARIO", "ACAO", "ID_CLIENT_REQUEST"].every(k => res[k] === req[k]);
}
export function layoutConfirmado(res, req) {
  return respostaLayout(res, req) && res.resultado === true && res.estado === "CONFIRMADO" && typeof res.TEXTO === "string" && typeof res.EXISTE === "boolean" &&
    (req.ACAO === "LER" || (res.EXISTE && res.TEXTO === req.TEXTO));
}
const reads = new Map();
export function requisitarLayoutPEP(api, jwt, dados) {
  const token = jwt.getToken();
  if(!token) { return Promise.reject(Object.assign(new Error("Confira a sessão antes de continuar."), { antesDoEnvio: true })); }
  const key = JSON.stringify([token, dados]);
  if(dados.ACAO === "LER" && reads.has(key)) { return reads.get(key); }
  const promise = Promise.resolve().then(async () => {
    api.setHeader(); const { data } = await api.postOnce("configuracoes/access/layoutProntuario", dados, { timeout: 120000 }); return data;
  }).finally(() => { if(reads.get(key) === promise) { reads.delete(key); } });
  if(dados.ACAO === "LER") { reads.set(key, promise); }
  return promise;
}
const editors = new WeakMap();
export function editorLayout(vm, uuid) {
  if(editors.has(vm)) { return editors.get(vm); }
  let epoch = 0, destroyed = false, loading = null, pending = null, operation = null, raw = "", existed = false, opened = false;
  const context = () => JSON.stringify([vm.usuario, vm.idEmitenteMLUsuario, vm.campo, vm.$route.fullPath]);
  const visible = () => vm.$refs.modal?.showModal && vm.$refs.modal?.showModalInside;
  const valid = req => !destroyed && visible() && req.epoch === epoch && req.context === context();
  const status = message => { vm.estado = { ocupada: !!operation, pendente: !!pending, mensagem: message }; };
  async function send(consultar) {
    const req = { ...pending, epoch, context: context() }; pending = req; operation = req; status(consultar ? "Consultando gravação…" : "Confirmando configuração…");
    try {
      let response, payload = { ...req.payload, ACAO: consultar ? "CONSULTAR" : "SALVAR" };
      try { response = await vm.requisitarLayoutPEP(payload); }
      catch(error) { if(valid(req) && error.antesDoEnvio && !consultar) { pending = null; status(error.message); return false; } }
      if(!valid(req)) { return false; }
      if(!consultar && respostaLayout(response, payload) && response.estado === "REJEITADO") { pending = null; status(response.mensagem || "A configuração não foi enviada. Sua edição foi preservada."); return false; }
      if(!consultar && !layoutConfirmado(response, payload)) {
        payload = { ...payload, ACAO: "CONSULTAR" };
        try { response = await vm.requisitarLayoutPEP(payload); } catch(error) { /* Somente consulta. */ }
      }
      if(!valid(req) || !layoutConfirmado(response, payload)) { return false; }
      const boards = decodificarLayout(vm.campo, response.TEXTO);
      pending = null; raw = response.TEXTO; existed = true; status("");
      vm.$emit("salvo", { TEXTO: raw, BOARDS: boards }); vm.$refs.modal.fecharModalInterno(); return true;
    } finally {
      if(operation === req) { operation = null; status(pending ? "Gravação ainda não confirmada. Consulte o resultado sem reenviar a configuração." : vm.estado.mensagem); }
    }
  }
  const c = {
    inicializar() {
      if(destroyed) { return Promise.resolve(false); }
      if(opened && (loading || vm.pronto || pending)) { return loading || Promise.resolve(vm.pronto); }
      opened = true;
      if(pending) { status("Há uma configuração sem confirmação. Consulte o resultado antes de editar."); return Promise.resolve(false); }
      return c.carregar();
    },
    carregar() {
      if(loading || operation || pending || !visible()) { return loading || Promise.resolve(false); }
      const req = { epoch, context: context() }; vm.carregando = true; vm.pronto = false; vm.invalido = false; status("");
      loading = Promise.resolve().then(async () => {
        try {
          const payload = pedidoLeituraLayout(vm.campo, vm.usuario), response = await vm.requisitarLayoutPEP(payload);
          if(!valid(req)) { return false; }
          if(!layoutConfirmado(response, payload)) { throw new Error("Não foi possível carregar a configuração. Tente novamente."); }
          raw = response.TEXTO; existed = response.EXISTE;
          try { vm.boards = decodificarLayout(vm.campo, raw); }
          catch(error) { vm.invalido = true; throw new Error("A configuração armazenada é inválida. Tente novamente ou escolha Usar padrão para preparar uma nova configuração."); }
          vm.pronto = true; return true;
        } catch(error) { if(valid(req)) { status(error.message); } return false; }
        finally { if(valid(req)) { loading = null; vm.carregando = false; } }
      });
      return loading;
    },
    padrao() { if(vm.invalido && !operation && !pending) { vm.boards = layoutPadrao(vm.campo); vm.pronto = true; vm.invalido = false; status("Padrão preparado. Salve para substituir a configuração anterior."); } },
    mover(dados) {
      if(!vm.pronto || operation || pending || !visible()) { return false; }
      try { vm.boards = moverItemLayout(vm.campo, vm.boards, dados); status(""); return true; }
      catch(error) { vm.boards = copiarLayout(vm.boards); status(error.message); return false; }
    },
    salvar() {
      if(!vm.pronto || operation || pending || !visible()) { return Promise.resolve(false); }
      const payload = { ...pedidoLeituraLayout(vm.campo, vm.usuario), ACAO: "SALVAR", ID_CLIENT_REQUEST: uuid(), TEXTO: codificarLayout(vm.campo, vm.boards), ANTERIOR: raw, EXISTIA: existed };
      pending = { payload, epoch, context: context() }; return send(false);
    },
    consultar() { return pending && !operation && visible() ? send(true) : Promise.resolve(false); },
    fechado() { epoch++; opened = false; loading = null; vm.carregando = false; if(!pending) { vm.pronto = false; } },
    invalidar() { c.fechado(); pending = null; operation = null; raw = ""; existed = false; vm.boards = []; vm.pronto = false; vm.invalido = false; status(""); if(visible()) { vm.$refs.modal.fecharModalInterno(); } },
    destruir() { c.invalidar(); destroyed = true; }
  };
  editors.set(vm, c); return c;
}
